import React,{useEffect} from 'react';
import { RouterProvider } from 'react-router-dom';
import { App as AntApp, message } from 'antd';
import routes from './routes';
import styles from '@/styles/App.module.scss';
import {useAppDispatch} from '@/store/hooks';
import { setMobile} from '@/store/slices/searchBarSlice';
import { setLocation } from '@/store/slices/userSlice';

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  //console.log('APP isMobile',isMobile);
  
  dispatch(setMobile(isMobile));
  useEffect(() => {
    if (!('geolocation' in navigator)) return;
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        dispatch(setLocation({ latitude, longitude }));
      },
      () => {
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  }, [dispatch]);
  return (
    <AntApp className={styles['AntApp']}>
      <RouterProvider router={routes} />
    </AntApp>
  );
};

export default App;   